import type { StoreProgressItem } from "../types";

interface StoreProgressProps {
  items: StoreProgressItem[];
  target: number;
  unit?: string;
}

/** Per-store mini progress bars with one SHARED target tick and right-aligned
 *  values — the `store_progress` section kind. Title renders in the enclosing
 *  shell/title row. */
export function StoreProgress({ items, target, unit = "%" }: StoreProgressProps) {
  return (
    <ul className="px-5 py-4 space-y-2">
      {items.map((s) => (
        <li key={s.label} className="flex items-center gap-3 text-sm">
          <span className="w-44 shrink-0 truncate text-foreground/90">{s.label}</span>
          <span className="relative flex-1 h-2 rounded-sm bg-muted/40">
            <span
              className="absolute inset-y-0 left-0 rounded-sm bg-primary/80"
              style={{ width: `${Math.min(100, Math.max(0, s.value))}%` }}
            />
            {/* Query-computed reference tick (e.g. portfolio average) — never
                labelled "target": invented-target language is banned by the
                dashboard spec's binding data rules. */}
            <span
              className="absolute -inset-y-1 w-0.5 bg-foreground/80"
              style={{ left: `calc(${target}% - 1px)` }}
              aria-label="Reference"
            />
          </span>
          <span className="w-12 text-right tabular-nums text-muted-foreground">
            {s.value.toLocaleString()}
            {unit}
          </span>
        </li>
      ))}
      <li className="flex items-center gap-3 pt-1 text-xs text-muted-foreground">
        <span className="w-44 shrink-0" />
        <span className="flex-1">
          shared reference tick = {target}
          {unit}
        </span>
        <span className="w-12" />
      </li>
    </ul>
  );
}
